webpackJsonp([114276838955818,60335399758886],{

/***/ 362:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 636:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(672);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(362);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hero_visas.0aff46bd.png";

/***/ }),

/***/ 671:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _config = __webpack_require__(14);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FontLoader = function () {
	  function FontLoader() {
	    _classCallCheck(this, FontLoader);
	  }
	
	  FontLoader.script = function script() {
	    return "\n    (function() {\n    \n      // FontFaceObserver https://github.com/bramstein/fontfaceobserver\n      var setupFontObserver = function(){\n        setupFontObserver = null;\n        (function(){function e(e,t){document.addEventListener?e.addEventListener(\"scroll\",t,!1):e.attachEvent(\"scroll\",t)}function t(e){document.body?e():document.addEventListener?document.addEventListener(\"DOMContentLoaded\",function t(){document.removeEventListener(\"DOMContentLoaded\",t),e()}):document.attachEvent(\"onreadystatechange\",function n(){if(\"interactive\"==document.readyState||\"complete\"==document.readyState)document.detachEvent(\"onreadystatechange\",n),e()})}function n(e){this.a=document.createElement(\"div\"),this.a.setAttribute(\"aria-hidden\",\"true\"),this.a.appendChild(document.createTextNode(e)),this.b=document.createElement(\"span\"),this.c=document.createElement(\"span\"),this.h=document.createElement(\"span\"),this.f=document.createElement(\"span\"),this.g=-1,this.b.style.cssText=\"max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;\",this.c.style.cssText=\"max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;\",this.f.style.cssText=\"max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;\",this.h.style.cssText=\"display:inline-block;width:200%;height:200%;font-size:16px;max-width:none;\",this.b.appendChild(this.h),this.c.appendChild(this.f),this.a.appendChild(this.b),this.a.appendChild(this.c)}function r(e,t){e.a.style.cssText=\"max-width:none;min-width:20px;min-height:20px;display:inline-block;overflow:hidden;position:absolute;width:auto;margin:0;padding:0;top:-999px;left:-999px;white-space:nowrap;font:\"+t+\";\"}function i(e){var t=e.a.offsetWidth,n=t+100;return e.f.style.width=n+\"px\",e.c.scrollLeft=n,e.b.scrollLeft=e.b.scrollWidth+100,e.g!==t?(e.g=t,!0):!1}function s(t,n){function r(){var e=s;i(e)&&null!==e.a.parentNode&&n(e.g)}var s=t;e(t.b,r),e(t.c,r),i(t)}function o(e,t){var n=t||{};this.family=e,this.style=n.style||\"normal\",this.weight=n.weight||\"normal\",this.stretch=n.stretch||\"normal\"}function l(){if(null===a){var e=document.createElement(\"div\");try{e.style.font=\"condensed 100px sans-serif\"}catch(t){}a=\"\"!==e.style.font}return a}function c(e,t){return[e.style,e.weight,l()?e.stretch:\"\",\"100px\",t].join(\" \")}var u=null,a=null,f=null;o.prototype.load=function(e,i){var o=this,a=e||\"BESbswy\",l=i||3e3,h=(new Date).getTime();return new Promise(function(e,i){null===f&&(f=!!window.FontFace);if(f){var p=new Promise(function(e,t){function n(){(new Date).getTime()-h>=l?t():document.fonts.load(c(o,o.family),a).then(function(t){1<=t.length?e():setTimeout(n,25)},function(){t()})}n()}),d=new Promise(function(e,t){setTimeout(t,l)});Promise.race([d,p]).then(function(){e(o)},function(){i(o)})}else t(function(){function t(){var t;if(t=-1!=m&&-1!=g||-1!=m&&-1!=S||-1!=g&&-1!=S)(t=m!=g&&m!=S&&g!=S)||(null===u&&(t=/AppleWebKit\\/([0-9]+)(?:\\.([0-9]+))/.exec(window.navigator.userAgent),u=!!t&&(536>parseInt(t[1],10)||536===parseInt(t[1],10)&&11>=parseInt(t[2],10))),t=u&&(m==x&&g==x&&S==x||m==T&&g==T&&S==T||m==N&&g==N&&S==N)),t=!t;t&&(null!==C.parentNode&&C.parentNode.removeChild(C),clearTimeout(L),e(o))}function f(){if((new Date).getTime()-h>=l)null!==C.parentNode&&C.parentNode.removeChild(C),i(o);else{var e=document.hidden;if(!0===e||void 0===e)m=p.a.offsetWidth,g=d.a.offsetWidth,S=v.a.offsetWidth,t();L=setTimeout(f,50)}}var p=new n(a),d=new n(a),v=new n(a),m=-1,g=-1,S=-1,x=-1,T=-1,N=-1,C=document.createElement(\"div\"),L=0;C.dir=\"ltr\",r(p,c(o,\"sans-serif\")),r(d,c(o,\"serif\")),r(v,c(o,\"monospace\")),C.appendChild(p.a),C.appendChild(d.a),C.appendChild(v.a),document.body.appendChild(C),x=p.a.offsetWidth,T=d.a.offsetWidth,N=v.a.offsetWidth,f(),s(p,function(e){m=e,t()}),r(p,c(o,'\"'+o.family+'\",sans-serif')),s(d,function(e){g=e,t()}),r(d,c(o,'\"'+o.family+'\",serif')),s(v,function(e){S=e,t()}),r(v,c(o,'\"'+o.family+'\",monospace'))})})},\"undefined\"!=typeof module?module.exports=o:(window.FontFaceObserver=o,window.FontFaceObserver.prototype.load=o.prototype.load)})();\n      }\n    \n      var fontBLoader = function(){\n        setupFontObserver && setupFontObserver();\n        var fontB = new FontFaceObserver('yococom');\n        fontB.load().then(function () {\n          document.documentElement.className += \" iconFontLoaded\";\n          console.log('Font load stage 2 (icon-font) complete');\n          // Optimization for Repeat Views\n          " + (_config2.default.development ? "" : "sessionStorage.iconFontLoaded = true;") + "\n        });\n      }\n    \n      // Optimization for Repeat Views\n      if( sessionStorage.yc_criticalFoftDataUriFontsLoaded ) {\n        document.documentElement.className += \" fontsLoadedStage1 fontsLoadedStage2\";\n        console.log('Font load stage 2 complete');\n        \n        if(!sessionStorage.iconFontLoaded){\n          fontBLoader();\n        }else{\n          document.documentElement.className += \" iconFontLoaded\";\n          console.log('Font load stage 2 (icon-font) complete')\n        }\n        return;\n      }\n      \n      setTimeout(function(){\n      setupFontObserver && setupFontObserver();\n      var fontASubset = new FontFaceObserver('basierCircle_Subset');\n      \n      var fontALoadedFunction = function() {\n        document.documentElement.className += \" fontsLoadedStage1\";\n        console.log('Font load stage 1 complete')\n        \n        var fontObsLoadCount = 0;\n        var onFontLoaded = function() {\n          fontObsLoadCount += 1;\n          if(fontObsLoadCount >= 4){\n            document.documentElement.className += \" fontsLoadedStage2\";\n            console.log('Font load stage 2 complete');\n            // Optimization for Repeat Views\n            " + (_config2.default.development ? "" : "sessionStorage.yc_criticalFoftDataUriFontsLoaded = true;") + "\n          }\n        };\n        \n        var fontA = new FontFaceObserver('basierCircle', {weight: 'normal'});\n        fontA.load().then(function () {\n          onFontLoaded();\n        }, function (error) {\n          onFontLoaded();\n        });\n        \n        var fontB = new FontFaceObserver('basierCircle', {weight: 'bold'});\n        fontB.load().then(function () {\n          onFontLoaded();\n        }, function (error) {\n          onFontLoaded();\n        });\n        \n        var fontC = new FontFaceObserver('basierCircle', {weight: 600});\n        fontC.load().then(function () {\n          onFontLoaded();\n        }, function (error) {\n          onFontLoaded();\n        });\n        \n        var fontD = new FontFaceObserver('basierCircle', {weight: 500});\n        fontD.load().then(function () {\n          onFontLoaded();\n        }, function (error) {\n          onFontLoaded();\n        });\n        \n        fontBLoader();\n      }\n      \n      fontASubset.load().then(function () { fontALoadedFunction() }, function () { fontALoadedFunction() });\n      }, 100);\n    })();\n    ";
	  };
	
	  return FontLoader;
	}();
	
	exports.default = FontLoader;
	module.exports = exports["default"];

/***/ }),

/***/ 672:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(17);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(21);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _config = __webpack_require__(14);
	
	var _config2 = _interopRequireDefault(_config);
	
	__webpack_require__(1152);
	
	var _fontLoader = __webpack_require__(671);
	
	var _fontLoader2 = _interopRequireDefault(_fontLoader);
	
	var _hero_visas = __webpack_require__(407);
	
	var _hero_visas2 = _interopRequireDefault(_hero_visas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PageTitle = "Process Credit Card Payments - Accept payments anywhere in SA → Yoco®";
	
	var criteoHome = "var dataLayer = dataLayer || [];\n    dataLayer.push({\n        event: 'crto_homepage',\n        crto: {\n            email: '##Users Email##' //can be empty string if email not known\n        }\n    });";
	
	var criteoProduct = "var dataLayer = dataLayer || [];\n    dataLayer.push({\n        event: 'crto_productpage',\n        crto: {\n            email: '', //can be empty string if email not known\n            products: ['Pro']\n        }\n    });";
	
	var criteoBasket = "var dataLayer = dataLayer || [];\ndataLayer.push({\n  event: 'crto_basketpage',\n  crto: {\n    email: '',  //can be empty string if email not known\n    products: [{\n      id: 'Pro',\n      price: '2799',\n      quantity: '1'\n    }] //add new object for each product added to cart.\n  }\n});";
	
	function checkCriteoTag(path) {
	  var dataLayer = "";
	
	  switch (path) {
	    case "/za/":
	      dataLayer = criteoHome;
	      break;
	    case "/za/about/":
	      dataLayer = criteoHome;
	      break;
	    case "/za/credit-card-readers/":
	      dataLayer = criteoProduct;
	      break;
	    case "/za/point-of-sale-app/":
	      dataLayer = criteoProduct;
	      break;
	    case "/za/portal/":
	      dataLayer = criteoProduct;
	      break;
	    case "/za/capital/":
	      dataLayer = criteoProduct;
	      break;
	    case "/za/signup/":
	      dataLayer = criteoBasket;
	      break;
	
	    default:
	      dataLayer = "";
	  }
	
	  if (dataLayer.length != 0) {
	    return _react2.default.createElement(
	      "script",
	      { type: "text/javascript" },
	      dataLayer
	    );
	  }
	}
	
	var TemplateWrapper = function TemplateWrapper(props) {
	  var children = props.children;
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      {
	        title: PageTitle,
	        meta: [{
	          name: "description",
	          content: "Process Credit Card Payments and start your business empire with Yoco, the #1 mobile card reader for South African small & medium businesses."
	        }]
	      },
	      _react2.default.createElement("meta", { content: _hero_visas2.default, property: "og:image" }),
	      _react2.default.createElement("meta", {
	        name: "viewport",
	        content: "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
	      }),
	      checkCriteoTag(props.location.pathname),
	      _react2.default.createElement(
	        "script",
	        null,
	        "\n          LUX = window.LUX || {};\n          LUX.samplerate = 100;\n          "
	      ),
	      _react2.default.createElement("script", {
	        src: "https://cdn.speedcurve.com/js/lux.js?id=157745041",
	        async: "true",
	        defer: "true"
	      }),
	      _react2.default.createElement(
	        "script",
	        { key: "fontLoader", type: "text/javascript" },
	        _fontLoader2.default.script()
	      ),
	      _react2.default.createElement(
	        "script",
	        null,
	        "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n        })(window,document,'script','dataLayer','GTM-N65QCC2');"
	      ),
	      _react2.default.createElement(
	        "script",
	        { key: "segment", type: "text/javascript" },
	        "\n          !function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error(\"Segment snippet included twice.\");else{analytics.invoked=!0;analytics.methods=[\"trackSubmit\",\"trackClick\",\"trackLink\",\"trackForm\",\"pageview\",\"identify\",\"reset\",\"group\",\"track\",\"ready\",\"alias\",\"debug\",\"page\",\"once\",\"off\",\"on\"];analytics.factory=function(t){return function(){var e=Array.prototype.slice.call(arguments);e.unshift(t);analytics.push(e);return analytics}};for(var t=0;t<analytics.methods.length;t++){var e=analytics.methods[t];analytics[e]=analytics.factory(e)}analytics.load=function(t,e){var n=document.createElement(\"script\");n.type=\"text/javascript\";n.async=!0;n.src=\"https://cdn.segment.com/analytics.js/v1/\"+t+\"/analytics.min.js\";var a=document.getElementsByTagName(\"script\")[0];a.parentNode.insertBefore(n,a);analytics._loadOptions=e};analytics.SNIPPET_VERSION=\"4.1.0\";\n            setTimeout(function(){analytics.load(\"" + _config2.default.segmentPublicKey + "\")}, 1000);\n            // called each time the page is loaded...\n            analytics.page();\n          }}();"
	      ),
	      _react2.default.createElement(
	        "script",
	        { type: "text/javascript" },
	        "(function(a,s,y,n,c,h,i,d,e){s.className+=' '+y;h.start=1*new Date;\n        h.end=i=function(){s.className=s.className.replace(RegExp(' ?'+y),'')};\n        (a[n]=a[n]||[]).hide=h;setTimeout(function(){i();h.end=null},c);h.timeout=c;\n        })(window,document.documentElement,'async-hide','dataLayer',500,\n        {'GTM-XXXXXX':true});"
	      ),
	      _react2.default.createElement(
	        "style",
	        { type: "text/css" },
	        ".async-hide { opacity: 0 !important}"
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: { backgroundColor: "white" } },
	      children()
	    ),
	    _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement("script", {
	        key: "zdChat",
	        type: "text/javascript",
	        dangerouslySetInnerHTML: {
	          __html: "setTimeout(function(){" + _config2.default.zendDesk + "}, 4000);"
	        }
	      }),
	      _react2.default.createElement("script", {
	        type: "text/javascript",
	        dangerouslySetInnerHTML: {
	          __html: "\n              function checkAsyncImages() {\n                [].forEach.call(document.querySelectorAll('img[data-src]'), function(img) {\n                  img.setAttribute('src', img.getAttribute('data-src'));\n                  img.onload = function() {\n                    img.removeAttribute('data-src');\n                  };\n                });\n\n                [].forEach.call(document.querySelectorAll('[data-src-bck]'), function(div) {\n                  div.style.backgroundImage = \"url(\" + div.getAttribute(\"data-src-bck\") + \")\";\n                  div.removeAttribute(\"data-src-bck\");\n                });\n              }\n\n              window.addEventListener('load', function() {\n                checkAsyncImages();\n\n                setInterval(checkAsyncImages, 500);\n              });\n            "
	        }
	      })
	    )
	  );
	};
	TemplateWrapper.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = TemplateWrapper;
	module.exports = exports["default"];

/***/ }),

/***/ 1152:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-b84e2303bbe738aea983.js